import { jsx as o } from "../../_virtual/jsx-runtime.mjs";
import * as a from "react";
import s from "./ReoCheckbox.mjs";
import v from "./ReoCheckboxGroupContext.mjs";
import d from "../../depend/classnames/index.mjs";
import { checkboxGroup as y } from "./css/ReoCheckbox.mjs";
const r = (e) => {
  const [t, b] = a.useState([]), l = a.useMemo(
    () => e.value ?? t,
    [e.value, t]
  ), h = a.useCallback((c, k) => {
    var m;
    const n = k ? [...l, c] : l.filter((C) => C !== c);
    e.value || b(n), (m = e.onChange) == null || m.call(e, n);
  }, [l, e]), x = a.useMemo(() => ({
    ghost: e.ghost,
    size: e.size,
    color: e.color,
    hoverColor: e.hoverColor,
    activeColor: e.activeColor,
    disabled: e.disabled,
    value: l,
    checkboxWrapClassName: e.checkboxWrapClassName,
    checkboxWrapStyle: e.checkboxWrapStyle,
    checkboxStyle: e.checkboxStyle,
    checkboxClassName: e.checkboxClassName,
    checkboxInnerClassName: e.checkboxInnerClassName,
    checkboxInnerStyle: e.checkboxInnerStyle,
    onChange: h
  }), [
    e.ghost,
    e.size,
    e.color,
    e.hoverColor,
    e.activeColor,
    e.checkboxWrapClassName,
    e.checkboxWrapStyle,
    e.disabled,
    e.checkboxStyle,
    e.checkboxClassName,
    e.checkboxInnerClassName,
    e.checkboxInnerStyle,
    l,
    h
  ]), u = a.useMemo(
    () => d(y, e.className),
    [e.className]
  ), i = a.useMemo(() => ({
    ...e.style
  }), [e.style]);
  return /* @__PURE__ */ o(v.Provider, { value: x, children: /* @__PURE__ */ o(
    "div",
    {
      className: u,
      style: i,
      children: e.options ? e.options.map((c) => /* @__PURE__ */ o(
        s,
        {
          value: c.value,
          theme: e == null ? void 0 : e.theme,
          children: c.label
        },
        c.value
      )) : e.children
    }
  ) });
};
r.displayName = "ReoCheckboxGroup";
export {
  r as default
};
//# sourceMappingURL=ReoCheckboxGroup.mjs.map
